import * as THREE from "three";
import { useDispatch, useSelector } from "react-redux";
import { Canvas } from "@react-three/fiber";
import { Suspense, useRef, useState } from "react";
import { OrbitControls, Html } from "@react-three/drei";

import Env from "./Env.jsx";
import Layout from "Pages/3dModel/Layout.jsx";
import BlockBCDModel from "./BlockBCDModel.jsx";
import CustomLoader from "./CustomLoader.jsx";

import { showHideBlockModel } from "Redux/General/ManageTag.js";
import { DEFAULT_ROTATE, ROTATE_DIFF } from "Helpers/Common.js";

const BLOCK_TAGS = [
  { name: "B1", position: [-2, 7, -16] },
  { name: "B2", position: [0, 5, -12] },
  { name: "B3", position: [5, 5, -6] },
  { name: "B4", position: [8, 5, -1] },
  { name: "B5", position: [13, 5, 7] },
  { name: "B6", position: [2, 5, 15] },
  { name: "B7", position: [-4, 5, 7] },
  { name: "B8", position: [-7, 5, 3] },
  { name: "B9", position: [-12, 5, -3] },
  { name: "B10", position: [-16, 7, -7] },
];

function BlockB() {
  const controls = useRef();
  const dispatch = useDispatch();
  const [rotateDegree, setRotationDegree] = useState(DEFAULT_ROTATE);
  const { isLabelShow } = useSelector((state) => state.ManageTag);

  return (
    <>
      <Layout rotateDegree={rotateDegree}>
        <Suspense fallback={<CustomLoader />}>
          <Canvas
            gl={{ outputColorSpace: THREE.SRGBColorSpace }}
            camera={{ fov: 45, near: 0.5, far: 200, position: [40, -15, -5] }}
          >
            <OrbitControls
              enableDamping={false}
              makeDefault
              maxDistance={50}
              minDistance={25}
              maxPolarAngle={Math.PI * 0.45}
              ref={controls}
              onChange={() => {
                const radians = controls.current.getAzimuthalAngle();
                setRotationDegree(radians * (180 / Math.PI) - ROTATE_DIFF);
              }}
            />
            <Env />
            <BlockBCDModel />

            {isLabelShow ? (
              BLOCK_TAGS.length > 0 &&
              BLOCK_TAGS.map((item) => (
                <Html
                  position={item.position}
                  key={item.name}
                  wrapperClass="Block_label"
                >
                  <span onClick={() => dispatch(showHideBlockModel(item.name))}>
                    {item.name}
                  </span>
                </Html>
              ))
            ) : (
              <></>
            )}

            {/* <Html position={[-2, 7, -16]} wrapperClass="Block_label">
                  B1
                </Html>
                <Html position={[0, 5, -12]} wrapperClass="Block_label">
                  B2
                </Html>
                <Html position={[5, 5, -6]} wrapperClass="Block_label">
                  B3
                </Html>
                <Html position={[8, 5, -1]} wrapperClass="Block_label">
                  B4
                </Html>
                <Html position={[13, 5, 7]} wrapperClass="Block_label">
                  B5
                </Html>
                <Html position={[2, 5, 15]} wrapperClass="Block_label">
                  B6
                </Html>
                <Html position={[-4, 5, 7]} wrapperClass="Block_label">
                  B7
                </Html>
                <Html position={[-7, 5, 3]} wrapperClass="Block_label">
                  B8
                </Html>
                <Html position={[-12, 5, -3]} wrapperClass="Block_label">
                  B9
                </Html>
                <Html position={[-16, 7, -7]} wrapperClass="Block_label">
                  B10
                </Html> */}
          </Canvas>
        </Suspense>
      </Layout>
    </>
  );
}

export default BlockB;
